{
  "options": {
    "errors": {
      "accessReject": "You don't have access to options",
      "notFoundOption": "Option not found",
      "failCreateOrder": "Fail create order"
    },
    "empty": "No options available for this ticker",
    "stockPrice": "Stock Price:",
    "columns": {
      "strike": "Strike",
      "bid": "Bid",
      "ask": "Ask",
      "last": "Last Price",
      "change": "Today %",
      "breakeven": "Breakeven",
      "volatility": "Implied Vol.",
      "interest": "Open Int.",
      "delta": "Delta",
      "gamma": "Gamma",
      "theta": "Theta",
      "vega": "Vega"
    },
    "actions": {
      "trade": "Trade",
      "info": "Info"
    }
  }
}
